import { Avatar, Button, Flex, Text } from '@collable/ui'
import Logo from '../../../../public/assets/collableLogo.svg'
import styled from '@emotion/styled'
import { useAuthContext } from '@/context/AuthContext'
import MenuNav from './MenuNav'
import { type Menu } from './type'
import { Link } from 'react-router'

interface HeaderProps {
  selectedMenu?: Menu
}

const Header = ({ selectedMenu }: HeaderProps) => {
  const { me, isLoggedIn } = useAuthContext()

  return (
    <Container as="header" alignItems="center">
      <Link to="/">
        <img src={Logo} alt="collable-logo" />
      </Link>
      <MenuNav selectedMenu={selectedMenu} />
      {isLoggedIn ? (
        <Link to="/my-page">
          <UserInfo alignItems="center" gap={10}>
            <Avatar size="l" type="person" />
            <Text size="body2" fontWeight="medium" color="labelNeutral">
              {me?.name}
            </Text>
          </UserInfo>
        </Link>
      ) : (
        <Link to="/auth/login">
          <Button kind="solid" color="primary" size="small">
            로그인
          </Button>
        </Link>
      )}
    </Container>
  )
}

export default Header

const Container = styled(Flex)`
  width: 100%;
  height: 80px;
  background-color: ${({ theme }) => theme.common.commonWhite};
  padding: 0 48px;
  position: sticky;
  top: 0;
  z-index: 100;
`

const UserInfo = styled(Flex)`
  background-color: ${({ theme }) => theme.common.commonWhite};
  padding: 8px;
  margin-left: auto;
`
